export const getDisplayApr = (incRewardsApr?: number, lpRewardsApr?: number) => {
  if ((incRewardsApr || incRewardsApr === 0) && (lpRewardsApr || lpRewardsApr === 0)) {
    return (incRewardsApr + lpRewardsApr).toLocaleString('en-US', { maximumFractionDigits: 2 })
  }
  if (incRewardsApr) {
    return incRewardsApr.toLocaleString('en-US', { maximumFractionDigits: 2 })
  }
  return null
}
